import { POSTLOGINLANDING } from "../global/urlMapping"
const CryptoJS = require("crypto-js");

export const EXPIRATION_TIME = 3600000
export const urlLogin = process.env.REACT_APP_BASEURL_GW + "/auth/loginUser?postLoginUriCustom=" + POSTLOGINLANDING;

export const crypt = (decryptedString) => {
    return CryptoJS.AES.encrypt(decryptedString, process.env.REACT_APP_KEY)
}

export const decrypt = (encryptedString) => {
    return CryptoJS.AES.decrypt(encryptedString, process.env.REACT_APP_KEY).toString(CryptoJS.enc.Utf8)
}
{/*
export const handleLogout = (authType) => {
    sessionStorage.clear();
    if (authType === SPID)
        (window.location.href = process.env.REACT_APP_BASEURL_GW + "/auth/logoutUser?postLogoutUriCustom=" + ROOT)
    if (authType === CFTNS) {
        window.location.href = ROOT
    }
}
*/}
export const generateHeadersCfTns = () => {
    const cftns = sessionStorage.CFTNS ? sessionStorage.CFTNS : sessionStorage.tempCFTNS;
    return {
        'Accept': '*/*',
        'Authorization': 'Bearer ' + process.env.REACT_APP_AUTH_TOKEN,
        'enduserattributes': decrypt(cftns),
    }
}

export const generateHeadersAuth = () => {
    return {
        'Accept': '*/*',
        'Authorization': 'Bearer ' + process.env.REACT_APP_AUTH_TOKEN,
    }
}

